// Synkkaa Leveys (listafiltteri) ⇄ slider. Ei vaikuta muihin filttereihin.
// Voi olla ladattuna aina; toimii vain .facet--width -lohkoissa.

(function () {
  "use strict";

  function initFacet(container) {
    var sliderHost = container.querySelector("price-range");
    if (!sliderHost) return;

    var minInput = sliderHost.querySelector(".price-range__input-min");
    var maxInput = sliderHost.querySelector(".price-range__input-max");
    var checkboxes = container.querySelectorAll(".js-width-checkbox");
    var facetMin = parseInt(container.getAttribute("data-min"), 10);
    var facetMax = parseInt(container.getAttribute("data-max"), 10);

    function apply(min, max) {
      var changed = false;
      var effectiveFacetMin = Number.isFinite(facetMin) ? facetMin : min;
      var effectiveFacetMax = Number.isFinite(facetMax) ? facetMax : max;
      var fullRange = min <= effectiveFacetMin && max >= effectiveFacetMax;
      checkboxes.forEach(function (cb) {
        var n = parseInt(cb.getAttribute("data-width"), 10);
        if (!Number.isFinite(n)) return;
        // Full width range means "no width filter".
        var should = !fullRange && n >= min && n <= max;
        if (cb.checked !== should) {
          cb.checked = should;
          changed = true;
        }
      });
      // Laukaistaan teeman oma "on change" -logiikka (AJAX/submit ym.)
      if (changed && checkboxes.length) {
        checkboxes[0].dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    function readBounds() {
      var min = parseInt(minInput.value, 10);
      var max = parseInt(maxInput.value, 10);
      if (isNaN(min) || isNaN(max)) return null;
      if (min > max) {
        var t = min; min = max; max = t;
      }
      return [min, max];
    }

    // Ensimmäinen synkka (jos oli aktiivisia arvoja)
    var initial = readBounds();
    var hasActive = Array.from(checkboxes).some(function (cb) { return cb.checked; });
    if (initial && hasActive) apply(initial[0], initial[1]);

    // Kuunnellaan muutoksia numero-inputeista (myös slider asettaa nämä)
    minInput.addEventListener("change", function () {
      var b = readBounds(); if (b) apply(b[0], b[1]);
    });
    maxInput.addEventListener("change", function () {
      var b = readBounds(); if (b) apply(b[0], b[1]);
    });
  }

  function initAll() {
    document.querySelectorAll(".facet--width").forEach(initFacet);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
